// extracted by mini-css-extract-plugin
export default {"panelButton":"panel-button_panelButton__ZtfPp hoverBackgroungColor"};